import Summary from 'ageas-react-component-summary'

import { useSimulatorStore } from '../../../Stores/simulatorStore'
import { useCoveragesStore } from '../../../Stores/useCoveragesStore'
import { AnimalsSecured } from '../../../Types/AnimalStore'
import { CoverageSelectedProps } from '../../../Types/coverages'
import { PRICE_TYPE } from '../../../constants/priceType'
import { t } from '../../../i18n'
import {
  ExpandedRow,
  ExpandedRowContainer,
  PackNameHeader,
  PackageTable,
  PackageTableHeader,
  PackageTableNameHeader,
  PackageTableRow,
  Table,
  TableContainer,
} from '../../TablePacks/styles'
import { CoverageRow } from '../CoverageRow'

export const Coverages = ({ data }: { data: AnimalsSecured }) => {
  const coverages = useCoveragesStore((state) => state.coverages)
  const { typeOfPrice } = useSimulatorStore()

  const allCoverages = data?.pack?.coverages?.map((coverage) => {
    const _coverage = coverages?.[`animal${data.id}`]?.find(
      (item) => item?.coverageId === coverage?.coverageId,
    )

    return {
      ...coverage,
      name: _coverage?.coverageName,
      order: _coverage?.order,
    }
  })

  const coverageMandatory = allCoverages
    ?.filter((item) => item?.mandatory)
    ?.sort((a: any, b: any) => a.order - b.order)

  const coverageOptional = allCoverages
    ?.filter((item) => !item?.mandatory && item?.isPreSelected)
    ?.sort((a: any, b: any) => a.order - b.order)

  return (
    <>
      <TableContainer>
        <Table>
          <tbody>
            <ExpandedRowContainer>
              <ExpandedRow colSpan={5}>
                <div className="expanded-row-item">
                  <PackageTable>
                    <thead style={{ width: '100%' }}>
                      <PackageTableRow>
                        <PackageTableNameHeader />
                        <PackageTableHeader>
                          <PackNameHeader>{data.pack?.packName}</PackNameHeader>
                          {data.pack?.price && (
                            <Summary
                              id="summaryPrice"
                              readOnly
                              newValue={data.pack?.price}
                              label={false}
                              periodCaption={PRICE_TYPE[typeOfPrice as never]}
                              colorTheme="blue"
                              unit="€"
                              version="2"
                            />
                          )}
                        </PackageTableHeader>
                      </PackageTableRow>
                    </thead>
                    <tbody>
                      <CoverageRow
                        isOpened
                        title={t('pages.step5.coverage.mandatory')}
                        data={coverageMandatory as CoverageSelectedProps[]}
                      />
                      {(coverageOptional || [])?.length > 0 && (
                        <CoverageRow
                          title={t('pages.step5.coverage.optional')}
                          data={coverageOptional as CoverageSelectedProps[]}
                        />
                      )}
                    </tbody>
                  </PackageTable>
                </div>
              </ExpandedRow>
            </ExpandedRowContainer>
          </tbody>
        </Table>
      </TableContainer>
    </>
  )
}
